import { render, staticRenderFns } from "./AlcoholSaleRestriction.vue?vue&type=template&id=193e8472"
import script from "./AlcoholSaleRestriction.vue?vue&type=script&lang=js"
export * from "./AlcoholSaleRestriction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports